import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import { Panel, Empty, axis, grid, tip, C } from "./chartTheme";
import { byDay } from "../../lib/reports";

export const TrendChart = ({ tests }) => {
  const data = byDay(tests).map((d) => ({ ...d, key: d.key.slice(5) }));
  return (
    <Panel title="Speed trend (daily average)" className="lg:col-span-2" testId="report-trend">
      {!data.length ? <Empty /> : (
        <ResponsiveContainer width="100%" height={260}>
          <LineChart data={data}>
            <CartesianGrid {...grid} />
            <XAxis dataKey="key" {...axis} />
            <YAxis yAxisId="l" {...axis} />
            <YAxis yAxisId="r" orientation="right" {...axis} />
            <Tooltip {...tip} />
            <Legend wrapperStyle={{ fontSize: 10 }} />
            <Line yAxisId="l" dataKey="dl" name="Download Mbps" stroke={C.blue} strokeWidth={2} dot={false} isAnimationActive={false} />
            <Line yAxisId="l" dataKey="ul" name="Upload Mbps" stroke={C.green} strokeWidth={2} dot={false} isAnimationActive={false} />
            <Line yAxisId="r" dataKey="ping" name="Ping ms" stroke={C.amber} strokeWidth={1.5} strokeDasharray="4 3" dot={false} isAnimationActive={false} />
          </LineChart>
        </ResponsiveContainer>
      )}
    </Panel>
  );
};
